<template>
  <div class="cpnt-cad-vis-relacionamento">
    <!-- SETA O CAMPO STATUS -->
    <RF-Status v-if='statusGeral !== ""' :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

    <!-- SETA A TABELA -->
    <div v-else-if='statusGeral === ""'>
      <div v-for="(campo, index) in quadrados" :key="index" class="quadrado">
        <table :data-time='time'>
          <tr>
            <td class="titulo">
              <span v-html="campo.nome" class="titulo"></span>
            </td>

            <td class="icone">
              <App-Icone v-if="[ '', null, undefined ].indexOf(campo.icone) === -1" :cpntTipo='campo.icone'></App-Icone>
            </td>
          </tr>
          <tr>
            <td class="valor" colspan="2">
              <span v-html="campo.valor" :class="campo.classes"></span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .cpnt-cad-vis-relacionamento {
    /* width: 645px; */
    max-width: 450px;
    width: 100%;
    margin: 0px auto;
  }
  .cpnt-cad-vis-relacionamento > div > .quadrado {
    text-align: left;
    padding: 8px 5px 8px 8px;
    margin: 5px;
    max-width: 215px;
    width: calc(50% - 10px);
    height: 75px;
    float: left;
    background: #fff;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
    .cpnt-cad-vis-relacionamento > div > .quadrado > table {
      width: 100%;
      height: 100%;
    }
      .cpnt-cad-vis-relacionamento > div > .quadrado > table > tr:first-child > td {
        height: 18px;
        vertical-align: top;
      }
      .cpnt-cad-vis-relacionamento > div > .quadrado > table > tr:last-child > td {
        height: calc(100% - 18px);
        vertical-align: bottom;
      }

      .cpnt-cad-vis-relacionamento > div > .quadrado > table > tr > td.icone {
        width: 20px;
        text-align: center;
      }
        .cpnt-cad-vis-relacionamento > div > .quadrado > table > tr > td.valor > .cor-amarelo {
          color: #ffc107;
        }
        .cpnt-cad-vis-relacionamento > div > .quadrado > table > tr > td.valor > .cor-vermelho {
          color: red;
        }
        .cpnt-cad-vis-relacionamento > div > .quadrado > table > tr > td.valor > .cor-verde {
          color: green;
        }
</style>

<style>
</style>

<script>
  // INICIA O PLUGIN MOMENT PARA CALCULAR A DATA
  var moment = require('moment')

  export default {
    props: {
      cpntTipo: {
        required: true,
        type: String
      },
      cpntRefId: {
        required: true,
        type: [ String, Number ]
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        dados: null,
        quadrados: [],
      }
    },
    mounted: function () {
      this.cpntVisualizarCadastroRelacionamentoIniciar()
    },
    methods: {
      cpntVisualizarCadastroRelacionamentoIniciar: function () {
        // SETA O STATUS DO CAMPO
        this.cpntVisualizarCadastroSetaStatusGeral('carregando')

        // INICIA A VARIAVEL DA ROTA
        var route = ''
        var method = 'POST'

        // INICIA A VARIAVEL DO QUERYGET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1 }, field: { id: null }, where: { f: 'id', o: '=', v: this.cpntRefId } }

        // VERIFICA A ROTA E OS CAMPOS QUE DEVE CHAMAR
        switch (this.cpntTipo) {
          case 'veiculo':
            // SETA A ROTA QUE VAI SER BUSCADO OS DADOS
            route = '/veiculo/get'

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'POST'

            // SETA OS FILDS VIRTUAIS QUE DEVE BUSCAR
            queryGet.field_virtual = [ ]

            // VERIFICA A PERMISSÃO DE VENDAS 
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, null, null, false) === true) {
              queryGet.field_virtual = queryGet.field_virtual.concat([
                "venda_venda_ultima_dataptbr",
                "venda_venda_ultima_cod_venda",
                'venda_orcamento_qtde',
                'venda_venda_qtde',
                'venda_venda',
                'venda_venda_servico',
                'venda_venda_produto',
                'venda_venda_ticket_medio'
              ])
            }
            break

          case 'pet':
            // SETA A ROTA QUE VAI SER BUSCADO OS DADOS
            route = '/pet/get'

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'POST'
            
            // SETA OS FILDS VIRTUAIS QUE DEVE BUSCAR
            queryGet.field_virtual = [ ]

            // VERIFICA A PERMISSÃO DE VENDAS 
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, null, null, false) === true) {
              queryGet.field_virtual = queryGet.field_virtual.concat([
                "venda_venda_ultima_dataptbr",
                "venda_venda_ultima_cod_venda",
                'venda_orcamento_qtde',
                'venda_venda_qtde',
                'venda_venda',
                'venda_venda_servico',
                'venda_venda_produto',
                'venda_venda_ticket_medio'
              ])
            }
            break

          case 'contato':
            // SETA A ROTA QUE VAI SER BUSCADO OS DADOS
            route = '/contato/get'

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'POST'

            // SETA OS FILDS VIRTUAIS QUE DEVE BUSCAR
            queryGet.field_virtual = []

            // VERIFICA SE DEVE MONTAR A COLUNA PARA PET
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, [ 561 ], null, false) === true) {
              queryGet.field_virtual = queryGet.field_virtual.concat([ 'qtde_pet' ])
            }

            // VERIFICA SE DEVE MONTAR A COLUNA PARA VEICULO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, [ 51 ], null, false) === true) {
              queryGet.field_virtual = queryGet.field_virtual.concat([ 'qtde_veiculo' ])
            }

            // VERIFICA SE TEM PACOTE FINANCEIRO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 4 ], null, [ 9 ], null, [ 11, 205 ], 'or', false) === true) {
              queryGet.field_virtual = queryGet.field_virtual.concat([
                'financeiro_qtde_sem',
                'financeiro_aberto',
                'financeiro_atraso'
              ])
            }

            // VERIFICA A PERMISSÃO DE VENDAS 
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, null, null, false) === true) {
              queryGet.field_virtual = queryGet.field_virtual.concat([
                "demanda_venda_venda_ultima_dataptbr",
                "demanda_venda_venda_ultima_cod_venda",
                'demanda_venda_orcamento_qtde',
                'demanda_venda_venda_qtde',
                'demanda_venda_venda',
                'demanda_venda_venda_servico',
                'demanda_venda_venda_produto',
                'demanda_venda_venda_ticket_medio'
              ])
            }

            // if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, null, null, false) === true) {
            //   queryGet.field_virtual = queryGet.field_virtual.concat([
            //     'demanda_compra_orcamento_qtde',
            //     'demanda_compra_compra_qtde',
            //     'demanda_compra_total_qtde'
            //   ])
            // }
            break
        }

        
        
        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI(route, method, queryGet, (apiSuccess) => {
          // SETA OS DADOS RECEBIDOS
          this.dados = apiSuccess.data[0]

          // CAMPOS QUE SERÁ FORMATADO PARA NUMERO
          var formatarNumeros = [ 'virtual_qtde_pet', 'virtual_qtde_veiculo', 'virtual_financeiro_qtde_sem', 'virtual_venda_venda_qtde', 'virtual_venda_orcamento_qtde' ]
          var formatarValores = [ 'virtual_venda_venda', 'virtual_venda_venda_produto', 'virtual_venda_venda_servico', 'virtual_financeiro_aberto', 'virtual_financeiro_atraso' ]

          // FORMATAR CAMPOS
          for (var index in this.dados) {
            if (formatarNumeros.indexOf(index) !== -1) {
              // VERIFICA SE TEM UM VALOR VALIDO PARA O CAMPO
              if ([ '', null, undefined ].indexOf(this.dados[index]) !== -1) {
                this.dados[index] = '0'
              }

              // CONVERTE EM NUMERO O VALOR RECEBIDO
              this.dados[index] = Number(this.dados[index])
            } else if (formatarValores.indexOf(index) !== -1) {
              // VERIFICA SE TEM UM VALOR VALIDO PARA O CAMPO
              if ([ '', null, undefined ].indexOf(this.dados[index]) !== -1) {
                this.dados[index] = '0,00'
              }

              // FORMATA EM REAIS O VALOR
              this.dados[index] = 'R$ ' + this.dados[index]
            }
            
            // GERA UM NOVO INDEX PARA O CAMPO
            var indexN = index.replace('_demanda', '')

            // SETA O VALOR DO CAMPO COM O NOVO INDEX
            this.dados[indexN] = this.dados[index]
          }

          // CHAMA A FUNÇÃO PARA ADICIONAR UM QUADRADO
          if (this.cpntTipo === 'contato') {
            // VERIFICA SE TEM A COLUNA PET
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, [ 561 ], null, false) === true) {
              this.cpntVisualizarCadastroQuadradoAdd('qtde_pet', 'Total de pet', this.dados.virtual_qtde_pet, [ 'cor-verde' ], 'pet')
            }

            // VERIFICA SE TEM O PACOTE VEICULO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, [ 51 ], null, false) === true) {
              this.cpntVisualizarCadastroQuadradoAdd('qtde_vei', 'Total de veículos', this.dados.virtual_qtde_veiculo, [ 'cor-verde' ], 'veiculo')
            }
          }

          // VERIFICA SE TEM O PACOTE VENDAS
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, null, null, false) === true) {
            // SETA A QUANIDADE DE ORÇAMENTOS
            if ([ '', null, undefined, '0', 0 ].indexOf(this.dados.virtual_demanda_venda_orcamento_qtde) === -1) {
              this.cpntVisualizarCadastroQuadradoAdd('qtde_ven_tp_1', 'Qtde de orçamentos', this.dados.virtual_venda_orcamento_qtde, [ 'cor-verde' ], 'copiar-01')
            }

            // SETA A QUANIDADE DE VENDAS
            if ([ '', null, undefined ].indexOf(this.dados.virtual_venda_venda_qtde) === -1) {
              this.cpntVisualizarCadastroQuadradoAdd('qtde_ven_tp_2', 'Qtde de vendas', this.dados.virtual_venda_venda_qtde, [ 'cor-verde' ], 'venda')
            }

            // CALCULA A DIFERENÇA DE DIAS
            var diffDias = ''
            var cor = ''

            // VERIFICA SE TEM ALGUM ORÇAMENTO
            if ([ '', null, undefined ].indexOf(this.dados.virtual_venda_orcamento_ultima_cod_venda) === -1) {
              // VERIFICA A DIFERENÇA DE DATAS
              diffDias = moment(this.dados.virtual_venda_ultima, 'DD/MM/YYYY').diff(moment(this.$store.state.dadosApi.datetime, 'YYYY-MM-DD'), 'days', true)
    
              // VERIFICA A COR QUE DEVE UTILIZAR
              cor = 'cor-verde'
              if (diffDias <= -14) {
                cor = 'cor-vermelho'
              } else if (diffDias >= -13 && diffDias <= -7) {
                cor = 'cor-amarelo'
              }

              // ADICIONA UM QUADRADO DA INFORMAÇÃO SOLICITADA
              this.cpntVisualizarCadastroQuadradoAdd('ultima_orcamento', 'Último orçamento', { valor: this.dados.virtual_venda_orcamento_ultima_dataptbr, extra: this.dados.virtual_venda_orcamento_ultima_cod_venda }, [ cor ], 'calendario')
            }

            // VERIFICA SE TEM ALGUMA VENDA
            if ([ '', null, undefined ].indexOf(this.dados.virtual_venda_ultima_cod_venda) === -1) {
              // VERIFICA A DIFERENÇA DE DATAS
              diffDias = moment(this.dados.virtual_venda_ultima, 'DD/MM/YYYY').diff(moment(this.$store.state.dadosApi.datetime, 'YYYY-MM-DD'), 'days', true)
    
              // VERIFICA A COR QUE DEVE UTILIZAR
              cor = 'cor-verde'
              if (diffDias <= -14) {
                cor = 'cor-vermelho'
              } else if (diffDias >= -13 && diffDias <= -7) {
                cor = 'cor-amarelo'
              }

              // ADICIONA UM QUADRADO DA INFORMAÇÃO SOLICITADA
              this.cpntVisualizarCadastroQuadradoAdd('ultima_venda', 'Última venda', { valor: this.dados.virtual_venda_ultima_dataptbr, extra: this.dados.virtual_venda_ultima_cod_venda }, [ cor ], 'calendario')
            }

            // SETA O VALOR TOTAL DAS VENDAS
            if ([ '', null, undefined ].indexOf(this.dados) === -1) {
              this.cpntVisualizarCadastroQuadradoAdd('total_geral', 'Venda total', this.dados.virtual_venda_venda, [ 'cor-verde' ], 'grafico')
            }

            // SETA O VALOR TOTAL DE PRODUTOS
            if ([ '', null, undefined ].indexOf(this.dados.virtual_venda_venda_produto) === -1) {
              this.cpntVisualizarCadastroQuadradoAdd('total_produto', 'Venda de produto', this.dados.virtual_venda_venda_produto, [ 'cor-verde' ], 'produto')
            }

            // SETA O VALOR TOTAL DE SERVIÇOS
            if ([ '', null, undefined ].indexOf(this.dados.virtual_venda_venda_servico) === -1) {
              this.cpntVisualizarCadastroQuadradoAdd('total_servico', 'Venda de serviço', this.dados.virtual_venda_venda_servico, [ 'cor-verde' ], 'servico')
            }

            // SETA O VALOR TOTAL DE SERVIÇOS
            if ([ '', null, undefined ].indexOf(this.dados.virtual_venda_venda_ticket_medio) === -1) {
              this.cpntVisualizarCadastroQuadradoAdd('ticket_medio', 'Ticket Médio', this.dados.virtual_venda_venda_ticket_medio, [ 'cor-verde' ], 'grafico-2')
            }
          }

          // VERIFIA SE TEM PACOTE FINANCEIRO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 4 ], null, [ 9 ], null, [ 11, 205 ], 'or', false) === true) {
            // SETA O QUADRADO DE FINANCEIRO EM ABERTO
            if ([ '', null, undefined, 'R$ 0,00' ].indexOf(this.dados.virtual_financeiro_aberto) === -1) {
              this.cpntVisualizarCadastroQuadradoAdd('financeiro_valor', 'Financeiro em aberto', this.dados.virtual_financeiro_aberto, [ 'cor-verde' ], 'financeiro')
            }
            // SETA O QUADRADO DE FINANCEIRO EM ATRASO
            if ([ '', null, undefined, 'R$ 0,00' ].indexOf(this.dados.virtual_financeiro_atraso) === -1) {
              this.cpntVisualizarCadastroQuadradoAdd('financeiro_valor_atraso', 'Financeiro em atraso', this.dados.virtual_financeiro_atraso, [ 'cor-vermelho' ], 'financeiro')
            }
            // SETA O QUADRADO DE VENDAS SEM FINANCEIRO
            if ([ '', null, undefined, '0', 0 ].indexOf(this.dados.virtual_financeiro_qtde_sem) === -1) {
              this.cpntVisualizarCadastroQuadradoAdd('venda_sem_financeiro', 'Venda s/ financeiro', this.dados.virtual_financeiro_qtde_sem, (this.dados.virtual_financeiro_qtde_sem >= 1 ? [ 'cor-vermelho' ] : [ 'cor-verde' ]), 'financeiro')
            }
          }

          // SETA O STATUS DO CAMPO
          this.cpntVisualizarCadastroSetaStatusGeral('')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, this.cpntVisualizarCadastroSetaStatusGeral)
      },
      cpntVisualizarCadastroSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cpntVisualizarCadastroQuadradoAdd: function (chave, nome, valores, classes = [ 'cor-verde' ], icone = '') {
        var order = 0

        switch (chave) {
          case 'qtde_vei':
            order = 1
            break
            
          case 'qtde_pet':
            order = 10
            break

          case 'ultima_orcamento':
            order = 20
            break
          case 'ultima_venda':
            order = 21
            break

          case 'qtde_ven_tp_1':
            order = 30
            break

          case 'qtde_ven_tp_2':
            order = 40
            break

          case 'venda_sem_financeiro_0':
            order = 50
            break
          case 'venda_sem_financeiro':
            order = 51
            break

          case 'total_produto':
            order = 60
            break

          case 'total_servico':
            order = 70
            break

          case 'total_geral':
            order = 80
            break

          case 'ticket_medio':
            order = 90
            break

          case 'financeiro_valor':
            order = 100
            break

          case 'financeiro_valor_atraso':
            order = 110
            break

          default:
            order = 999
            break
        }

        // VERIFICA SE O PARAMETRO RECEBIDO É UM VETOR
        if ([ 'string', 'number' ].indexOf(typeof valores) !== -1) {
          valores = { valor: valores, extra: valores }
        }

        // ADICIONA O VALOR RECEBIDO A TELA
        this.quadrados.push({ chave: chave, nome: nome, valor: valores.valor, extra: valores.extra, icone: icone, classes: classes, order: order })

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        // CHAMA A FUNÇÃO PARA ORDENAR O VETOR
        this.cpntVisualizarCadastroOrdenarVetor()
      },
      cpntVisualizarCadastroOrdenarVetor: function () {
        // ORDENA O VETOR COM OS PACOTES DISPONIVEIS
        this.quadrados = this.quadrados.sort((a, b) => { return a.order < b.order ? -1 : a.order > b.order ? 1 : 0 })
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
    }
  }
</script>
